export default {
    name: "hypo-workflow-mixin",
    data() {
        return {
            headerOptions: [
                {
                    label: "Rename",
                    trigger: "rename"
                },
                {
                    label: "Delete",
                    trigger: "delete"
                }
            ],
            notificationAction: "notifications/showNotification",
            headerText: `Hypothetical: ${this.$store.getters["hypo/getName"]}`,
            workflowLoader: false,
            defaultDialogConfig: {
                mainText: "common_delete_hypo_dialog_title",
                dialogType: "hypo", // "hypo", "portfolio"
                action: "delete", // "rename", "delete"
                dismissLabel: "common_cancel",
                executeLabel: "common_delete"
            },
            stepperLinksMap: {}
        };
    },
    computed: {
        currentStep() {
            return this.$store.getters["stepper/getCurrentStep"];
        }
    },
    methods: {
        getHeaderOptions() {
            return this.$store.state.hypo.firmSaved ? this.headerOptions.filter(item => item.label !== "Delete") : this.headerOptions;
        },
        getHeaderText() {
            return this.headerText;
        },
        getDialogDefaultConfig() {
            return this.defaultDialogConfig;
        },
        getDialogConfig(action, dialogType, portfolioIndex) {
            return {
                mainText: `common_${action}_${dialogType}_dialog_title`,
                dialogType,
                action,
                dismissLabel: "common_cancel",
                executeLabel: `common_${action}`,
                portfolioIndex
            };
        },
        dialogCloseHandler() {
            this.showDialog = false;
        },
        renameHypoFile(newName) {
            this.$store.commit("hypo/SET_HYPO_NAME", newName);
            if (this.$store.getters["hypoInput"].hypoId) {
                this.workflowLoader = true;
                this.$store.dispatch("hypo/renameHypo", { fetch: this.$fetch }).then(() => (this.workflowLoader = false));
            }
        },
        checkAvailableName(newName) {
            const hypoList = this.$store.getters["notifications/getHypoList"];
            return !hypoList.some(hypo => hypo.hypoName.trim() === newName.trim());
        },
        deleteHypoFile() {
            const { hypo } = this.$store.state;
            if (!hypo.hypoId) {
                this.$store.commit("hypo/RESET");
                this.$router.push("/type");
            } else {
                this.workflowLoader = true;
                this.$fetch({
                    url: "/api/v1/Hypo/BatchDelete",
                    method: "POST",
                    body: JSON.stringify([hypo.hypoId])
                }).then(() => {
                    this.workflowLoader = false;
                    const notification = {
                        size: "small",
                        variation: "success",
                        title: "",
                        persistent: false,
                        text: `${hypo.hypoName} has been successfully deleted.`
                    };
                    this.$store.dispatch(this.notificationAction, notification);
                    this.$router.push("/type");
                });
            }
        },
        showErrorNotification(message, title) {
            const notification = {
                size: "medium",
                variation: "error",
                title: title,
                persistent: false,
                text: message,
                duration: 0
            };
            this.$store.dispatch(this.notificationAction, notification);
        },
        renamePortfolio(newName, portfolioNumber) {
            const payload = {
                newName,
                portfolioNumber
            };
            this.$store.dispatch("investments/renamePortfolio", payload);
        },
        saveLastStep(keyString) {
            this.$store.commit("hypo/SET_HYPO_LAST_COMPLETED_STEP", keyString);
        },
        showCloseNotification(type, text, duration = 3000) {
            const notification = {
                size: "medium",
                variation: type,
                title: "",
                persistent: false,
                duration,
                text
            };
            this.$store.dispatch(this.notificationAction, notification);
        },
        handleSaveDialog(event) {
            // Cancel button clicked
            if (!event) {
                this.showSaveDialog = false;
            }
            // Save button clicked
            else if (!event.hasError) {
                this.saveHypoFile();
            }
        },
        checkHypoCount() {
            const isSavedHypoFile = this.$store.state.hypo.hypoId !== "";
            const totalCount = this.$store.getters["notifications/getHypoCount"];
            const actualFileLimit = this.$store.getters["config/getSavedHyposLimit"];
            if (isSavedHypoFile || totalCount < actualFileLimit) {
                this.showSaveDialog = true;
            } else {
                this.showCloseNotification(
                    "warning",
                    `You have exceeded the maximum number ${actualFileLimit} of 
                    online saved hypothetical illustrations. Your newly created hypothetical 
                    illustration will not be saved online unless you delete an existing online saved 
                    illustration.`,
                    0
                );
                this.$router.push("/type");
            }
        },
        saveHypoFile() {
            this.$store
                .dispatch("saveHypo", {
                    fetch: this.$fetch
                })
                .then(() => {
                    this.showCloseNotification("success", `${this.$store.state.hypo.hypoName} has been successfully saved.`);
                    this.$router.push("/type");
                    this.workflowLoader = false;
                })
                .catch(err => console.log(err));
        },
        getPCTToken() {
            return this.$fetch({
                url: `/api/v1/auth/getcomponenttoken`,
                method: "GET"
            });
        },
        getSecuritiesInfo(secIds) {
            return this.$fetch({
                url: "/api/v1/security/basic",
                method: "POST",
                body: JSON.stringify(secIds)
            });
        },
        getPortfolioNumber(portfolioIndex) {
            const hypoType = parseInt(this.$store.getters["hypo/getType"]);
            return hypoType === 1 ? parseInt(portfolioIndex) + 1 : null;
        }
    }
};
